/**
 * @author Ivan Toth.
 */
var DetailTableComplClValidationController = (function () {
    function DetailTableComplClValidationController(topic, $scope) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.tableName = 'Validation Checklist';
        this.displayRadioButton = true;
        this.showThumb = true; //will show on section header
        this.lock = false;
        this.comp = 'complcl_validation';
        this.updateArray = ['complcl_validation'];
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp)) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
        });
        this.overallFindGOEResult = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government', 'No Results Found'];
        this.overallGoeIndicator = ['Government Owned Entity', 'State Owned Enterprise', 'Unknown', 'Non-Government'];
        this.goeDeterminant = ['FindGOE Tool', 'Exception list', 'IntOrg list', 'DUNS tab check', 'PEP check', 'GOE Team', 'NGE Declaration Process', 'SO name Clarification'];
        this.declarationLetter = ['Yes', 'No'];
    }
    ;
    DetailTableComplClValidationController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailTableComplClValidationController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
    };
    DetailTableComplClValidationController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            if (this.topic.updatePartialSocketStatus(this.updateArray, 'upd')) {
                if (_.get(this, 'topic.checksData.isAutoEligibilityGoe', false)) {
                    _.set(this, 'topic.temp.complcl_validation.isAutoGoeEligibility', true);
                    var updateObject = {
                        data: {
                            complcl_validation: {
                                add: true,
                                data: this.topic.temp.complcl_validation
                            }
                        },
                        id: this.topic.topic._id,
                        type: ['complcl_validation']
                    };
                    console.log('send for update');
                    this.topic.updateServerTopic('couchUpdate', updateObject, true);
                }
                else {
                    this.topic.sendForUpdateGeneral(this.updateArray, true);
                }
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
            // Check if we can update the values if yes continue to update temp
            this.edit.editMode = this.topic.setTopicFromTempPart(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableComplClValidationController.prototype.itemChanged = function (line) { };
    DetailTableComplClValidationController.$inject = ['topic', '$scope'];
    return DetailTableComplClValidationController;
}());
var DetailTableComplClValidatioComponent = (function () {
    function DetailTableComplClValidatioComponent() {
        this.templateUrl = 'detail-table-complcl.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableComplClValidationController;
    }
    return DetailTableComplClValidatioComponent;
}());
angular
    .module('application')
    .component('detailTableComplClValidation', new DetailTableComplClValidatioComponent());

//# sourceMappingURL=detail.table.complcl.validation.component.js.map
